module.exports = {"id":"214609","name":"Sherman Cárdenas","rating":"71","photo":"./data/images/photos/1/214609.png","club":{"name":"Atlético Bucaramanga","logo":"./data/images/clubs/AtleticoBucaramanga.png"},"positions":["MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShermanCardenas0.json
// module id = 3936
// module chunks = 0